import { isBoolean } from 'lodash';

export const initialPetComplete = (ctx, { payload }) => {
  const pet = payload.pets.find(p => p.id === payload.pet_id);
  return (
    !!pet?.name && !!pet?.weight && !!pet?.activity_level && !!pet?.is_neutered
  );
};

export const hasPet = (ctx, { payload }) => {
  return (
    !!ctx.pet.id ||
    !!payload.pet?.id ||
    !!payload.pets?.[0]?.id ||
    !!payload.pet_id
  );
};

export const hasPetName = (ctx, { payload }) => {
  return !!ctx?.pet?.name || !!payload.pet?.name;
};

export const hasPetGender = (ctx, action) => {
  return !!ctx?.pet?.gender;
};

export const hasPetStatus = ctx => {
  return ctx?.pet?.is_neutered !== null;
};

export const hasInitialPetWeight = (ctx, action) => {
  return !!ctx?.pet?.weight;
};

export const hasPetWeight = (ctx, { payload }) => {
  return !!ctx.pet?.weight || !!payload.pet?.weight;
};

export const isInitialFlow = (ctx, action) => {
  return action.type === 'initialLoad' || ctx.initialFlow;
};

export const hasInitialPetActivity = (ctx, action) => {
  return !!ctx.pet?.activity_level;
};

export const hasPetActivity = (ctx, { payload }) => {
  return !!ctx.pet?.activity_level || !!payload.pet?.activity_level;
};

export const isCompletePet = pet => {
  const isComplete =
    !!pet.name &&
    !!pet.weight &&
    !!pet.activity_level &&
    isBoolean(pet.is_neutered);

  return isComplete;
};

export const allPetsComplete = (ctx, { payload }) => {
  const allComplete =
    (!!payload.pets?.length && payload.pets.every(pet => isCompletePet(pet))) ||
    (!!ctx.pets?.length && ctx.pets.every(pet => isCompletePet(pet)));

  return allComplete;
};

export const isAddPup = (ctx, { payload }) => !!payload.isAddPet;

export const isEditPet = (ctx, { payload }) => !!payload.isEditPet;

export const notAddPup = (ctx, { payload }) => !payload.isAddPet;

export const notEditPet = (ctx, { payload }) => !payload.isEditPet;

export const isDeletePet = (ctx, { payload }) => {
  return !!payload.isDeletePet;
};

export const allPetsHaveProductInCart = (ctx, { payload }) => {
  return (
    !!payload.pets?.length && payload.pets?.every(pet => !!pet.starter_box)
  );
};

export const hasMealPrep = (ctx, payload) => {
  return !!ctx?.pet?.starter_box || !!payload?.pet?.starter_box;
};

export const submitCartFailed = (ctx, payload) => !payload.data.success;

export const showGiftOnboardingStep = ctx => {
  const showStep = ctx?.flags?.showGiftOnboardingStep ?? false;

  return showStep;
};

export const showQuizAbandonerMenu = (ctx, { payload }) => {
  const combinedFlags = { ...(ctx?.flags || {}), ...(payload?.flags || {}) };
  return !!combinedFlags?.showQuizAbandonerMenu;
};
